"use client";

import { LegacyProviders } from "@/components/next/LegacyProviders";
import { MainAppLayout } from "@/components/next/MainAppLayout";
import { isSupportedLocale } from "@/lib/i18n/config";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

const PLAIN_ROUTE_PREFIXES = ["/booting", "/forgotpassword", "/network-error", "/test"];

function normalizeLocalePathname(pathname: string) {
  const [, maybeLocale, ...rest] = pathname.split("/");
  if (isSupportedLocale(maybeLocale)) {
    const normalized = `/${rest.join("/")}`.replace(/\/+$/, "");
    return normalized || "/";
  }

  return pathname.replace(/\/+$/, "") || "/";
}

function shouldUsePlainLayout(pathname: string) {
  const normalizedPathname = normalizeLocalePathname(pathname);
  return PLAIN_ROUTE_PREFIXES.some((prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`));
}

export function LocaleAppShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const content = shouldUsePlainLayout(pathname) ? children : <MainAppLayout>{children}</MainAppLayout>;

  return <LegacyProviders>{content}</LegacyProviders>;
}
